import { render, staticRenderFns } from "./CommissionList.vue?vue&type=template&id=52802a30&scoped=true&"
import script from "./CommissionList.vue?vue&type=script&lang=js&"
export * from "./CommissionList.vue?vue&type=script&lang=js&"
import style0 from "./CommissionList.vue?vue&type=style&index=0&id=52802a30&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52802a30",
  null
  
)

export default component.exports